import {Params} from '@feathersjs/feathers'

import {ProviderId, ProviderServiceOffer} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'providerServiceOffer'

const get = async (params?: Params) => feathersService.find<ProviderServiceOffer>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const create = async (payload: Omit<ProviderServiceOffer, 'id'>) =>
  feathersService.create<ProviderServiceOffer, Omit<ProviderServiceOffer, 'id'>>(RESOURCE, payload)

export const createMultiple = async (payload: Omit<ProviderServiceOffer, 'id'>[]) =>
  payload.length > 0
    ? feathersService.createMultiple<ProviderServiceOffer, Omit<ProviderServiceOffer, 'id'>>(
        RESOURCE,
        payload
      )
    : Promise.resolve([])

export const remove = async (id: string) =>
  feathersService.remove<ProviderServiceOffer>(RESOURCE, id)

export const removeMultiple = async (ids: string[]) => Promise.all(ids.map(id => remove(id)))
